module.exports = __webpack_public_path__ + "img/dunaint5.b1a4a369.png";